module.exports = __webpack_public_path__ + "img/img20.2ec489a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/07/img20.jpg
// module id = 286
// module chunks = 0